import { Card, Button, Row, Col, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTag, FaPalette, FaRuler, FaCog } from 'react-icons/fa';
import PageFade from '../../components/animation/PageFade';

export default function Settings() {
  return (
    <PageFade>
      <Row className="g-4">
        <Col md={12}>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title>
                <FaCog className="me-2" />
                Settings & Management
              </Card.Title>
              <Card.Text className="text-muted">
                Manage your store's categories, colors, sizes, and other settings.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title>
                <FaTag className="me-2" />
                Categories
              </Card.Title>
              <Card.Text className="text-muted">Manage product categories</Card.Text>
              <Button as={Link} to="/categories" variant="primary" className="w-100">
                Manage Categories
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title>
                <FaPalette className="me-2" />
                Colors
              </Card.Title>
              <Card.Text className="text-muted">Manage product colors</Card.Text>
              <Button as={Link} to="/colors" variant="primary" className="w-100">
                Manage Colors
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm h-100">
            <Card.Body>
              <Card.Title>
                <FaRuler className="me-2" />
                Sizes
              </Card.Title>
              <Card.Text className="text-muted">Manage product sizes</Card.Text>
              <Button as={Link} to="/sizes" variant="primary" className="w-100">
                Manage Sizes
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </PageFade>
  );
}

